import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileApiService } from '../../../../projects/api/src/user/profile/profile-api.service';
import { CompanyModel } from '../../../../projects/api/src/user/user.model';
import {AuthenticationApiService} from '../../../../projects/api/src/authentication/authentication-api.service';
import {map} from 'rxjs/operators';
import {IsAuthorizedService} from '../../shared/services/is-authorized.service';

@Injectable()
export class CurrentCompanyResolver  {
  constructor(
    private isAuthorizedService: IsAuthorizedService,
    private api: AuthenticationApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CompanyModel> | Promise<CompanyModel> | CompanyModel {
    return this.api.userStatus()
      .pipe(
        map((info) => {
            if (info.authenticated) {
              return info.company;
            } else {
              this.isAuthorizedService.isAuthorized.next(false);
              setTimeout(() => {
                window.location.href = '#!/login';
              });
              throw new Error('Not authenticated');

            }
          }
        ));
  }

}

@Injectable()
export class CompaniesResolver  {
  constructor(private api: ProfileApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CompanyModel[]> | Promise<CompanyModel[]> | CompanyModel[] {
    return this.api.readCompanies();
  }

}
